<script setup>
import EmbPartyReport from './emb-party-report.vue'

definePage({
  meta: {
    subject: 'Embroidery Party Report',
  },
})
</script>

<template>
  <EmbPartyReport />
</template>
